/* Catalog loader — arma window.CATALOG desde /products.json (endpoint público de Shopify).
   Ventaja: es INDEPENDIENTE del theme → funciona en preview sin publicar Y en producción
   (el endpoint de template alterno solo existía en el theme publicado, por eso el preview salía vacío).
   Pagina de 250. La CATEGORÍA se deriva del TIPO de producto (decisión de Kike #3).

   Uso desde las páginas:  window.onCatalog(function(CATALOG){ ...init... }); */
(function(){
  window.CATALOG = window.CATALOG || { products: [], ready: false };
  var queue = [];
  window.onCatalog = function(cb){
    if (window.CATALOG.ready) { cb(window.CATALOG); return; }
    queue.push(cb);
  };

  /* Mapa Tipo→categoría (de los 24 product_type reales del catálogo). */
  var TYPE_CAT = {
    // tenis
    "High Top":"tenis", "Low Top":"tenis", "Comfort":"tenis", "Calzado":"tenis",
    // accesorios
    "Gorra":"accesorios", "Lentes":"accesorios", "Bolsa":"accesorios", "Reloj":"accesorios",
    "Coleccionables":"accesorios", "Otro":"accesorios",
    // ropa
    "T-shirts":"ropa", "Hoodie":"ropa", "Baby-tee":"ropa", "Ropa":"ropa", "Jersey":"ropa",
    "Jeans":"ropa", "Shirt":"ropa", "Sweater":"ropa", "Short":"ropa", "Tank top":"ropa",
    "Pants":"ropa", "Crewneck":"ropa", "Long sleeve":"ropa"
  };
  function categoryOf(type, variants){
    if (type && TYPE_CAT[type]) return TYPE_CAT[type];
    // sin tipo mapeado: tallas CM/EU ⇒ tenis, si no ropa
    var hasCmEu = (variants || []).some(function(v){ return /\bCM\b|\bEU\b/i.test(String(v.size)); });
    return hasCmEu ? "tenis" : "ropa";
  }
  function num(x){ var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n); }

  function mapProduct(p){
    var variants = (p.variants || []).map(function(v){
      var size = v.title === "Default Title" ? "Unitalla" : v.title;
      var price = num(v.price);
      var cmp = v.compare_at_price ? num(v.compare_at_price) : null;
      return {
        id: v.id, size: size, price: price,
        compareAt: (cmp && cmp > price) ? cmp : null,
        available: !!v.available,
        qty: v.available ? 99 : 0   // /products.json no expone inventario; 99 evita falsos "última pieza"
      };
    });
    return {
      handle: p.handle,
      title: p.title,
      brand: p.vendor || "",
      type: p.product_type || "",
      category: categoryOf(p.product_type, variants),
      bg: "blanco",   // tratamiento de foto (auto-detección en cliente = siguiente iteración)
      images: (p.images || []).map(function(im){ return im.src; }),
      variants: variants
    };
  }

  function finish(){
    window.CATALOG.ready = true;
    try { document.dispatchEvent(new CustomEvent("catalog:ready")); } catch(e){}
    queue.splice(0).forEach(function(cb){ try { cb(window.CATALOG); } catch(e){ console.error(e); } });
  }

  function fetchPage(page){
    return fetch("/products.json?limit=250&page=" + page, { headers: { "Accept": "application/json" } })
      .then(function(r){ if (!r.ok) throw new Error("products.json p" + page + " -> " + r.status); return r.json(); })
      .then(function(d){ return (d && d.products) || []; });
  }

  (function loadAll(){
    var all = [];
    function next(page){
      return fetchPage(page).then(function(ps){
        if (!ps.length) return all;
        all = all.concat(ps);
        return ps.length < 250 ? all : next(page + 1); // página llena ⇒ puede haber más
      });
    }
    next(1).then(function(list){
      window.CATALOG.products = list.map(mapProduct);
      finish();
    }).catch(function(e){ console.error("[catalog] load failed:", e); finish(); });
  })();
})();
